import Swiper, { Navigation, Pagination } from "swiper"
Swiper.use([Navigation, Pagination])
export default new (class RecommendationsCarousel {
    constructor() {
        this.sliderContainerSelector = "_carousel-recommendations"
        this.sliderPaginationSelector = "_carousel-recommendations-pagination"
        this.sliderNextSelector = "_carousel-recommendations-next"
        this.sliderPrevSelector = "_carousel-recommendations-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            new Swiper(item, {
                slidesPerView: 3,
                spaceBetween: 40,
                pagination: {
                    el: item.parentElement.querySelector(`.${this.sliderPaginationSelector}`),
                    clickable: true,
                    bulletClass: 'swiper-pagination-line',
                },
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 12,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 8,
                    },
                },
            })
        })
    }
})()
